import { isUndefined } from '../helpers'
import en from './en/en'
import fr from './fr/fr'

const languages = {
  fr,
  en
}

const getLocale = _ => languages[locale]

const getFile = file => getLocale()[file.toUpperCase()]

const getAttribute = (file, attribute) => getFile(file)[attribute]

const getAttributeWhenNotFound = (attribute, type) => isUndefined(type)
  ? attribute
  : (attribute + '.' + type)

const getTrad = (file, attribute, type) => {
  const attributeTrad = getAttribute(file, attribute)
  if (isUndefined(attributeTrad)) return getAttributeWhenNotFound(attribute, type)

  return isUndefined(type)
    ? attributeTrad
    : attributeTrad[type] || getAttributeWhenNotFound(attribute, type)
}

export default (fullAttribute) => {
  return getTrad(...fullAttribute.split('.'))
}
